import { Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiIdentificationCard } from 'react-icons/pi';
import { ILabelForm } from 'services/labels/types';
import { useStateStorage } from 'store/state';

const LabelSupervisor = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<ILabelForm>();

  const { countries } = useStateStorage();

  const countrySelectOptions =
    countries?.map(country => ({
      label: t(`countries.${country.codeAlfa2}`),
      value: country.codeAlfa2,
    })) ?? [];

  return (
    <Container className='self-start w-full max-w-[350px]'>
      <Container.Header
        title={
          <>
            <PiIdentificationCard /> {t('label.supervisor.header')}
          </>
        }
      />
      <Container.Content>
        <div className='flex flex-col w-full gap-3'>
          <FormInput.Select
            name='legalSupervisorCountryAlfa2'
            label={t('input.label.country')}
            options={countrySelectOptions}
          />
          <FormInput.Text
            name='legalSupervisorPersonalId'
            label={t('input.label.personalId')}
          />
          <FormInput.Text
            name='legalSupervisorFirstName'
            label={t('input.label.firstName')}
          />
          <FormInput.Text
            name='legalSupervisorLastName'
            label={t('input.label.lastName')}
          />
        </div>
      </Container.Content>
    </Container>
  );
};

export default LabelSupervisor;
